(function () {
  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getSeriesFromAlt(alt) {
    if (!alt) return null;

    const match = alt.match(/#Series_(.+)$/i);
    return match ? normalize(match[1]) : null;
  }

  function filterGallery(selectedSeries) {
    const selected = normalize(selectedSeries);

    if (!selected) return;

    document
      .querySelectorAll('.product-gallery__media')
      .forEach((media) => {
        const img = media.querySelector('img');

        if (!img) return;

        const seriesTag = getSeriesFromAlt(img.alt);

        // Untagged images remain universal.
        if (!seriesTag) return;

        const shouldShow = seriesTag === selected;

        media.hidden = !shouldShow;
        media.style.display = shouldShow ? '' : 'none';

        // Remove Prestige's special first-image state if it belongs
        // to a different variant.
        if (!shouldShow) {
          media.classList.remove('is-initial');
        }
      });
  }

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;

    if (!variant) return;

    /*
      On this product, Series is the variant title:
      991/981/718
      992 | MY 2020+
      997/987
      Macan | 95B
    */
    const selectedSeries = variant.title;

    // Let Prestige finish its own gallery handling first.
    setTimeout(() => filterGallery(selectedSeries), 50);
    setTimeout(() => filterGallery(selectedSeries), 250);
  });
})();
/* ============================================================
   RennMount YMM Search → Correct Shopify Variant
   ------------------------------------------------------------
   YMM searches at the product level, but supplies generation
   information in the search URL. Shopify exposes all returned
   product variants in ShopifyAnalytics.meta.products.

   This code:
   1. Reads the selected Porsche generation from the YMM URL
   2. Finds the corresponding variant for each search result
   3. Adds ?variant=xxxxx to every product-card link
   4. Updates Prestige quick-buy to the same correct variant
   ============================================================ */

(function () {
  if (window.location.pathname !== '/search') return;

  const params = new URLSearchParams(window.location.search);

  const make = params.get('make');
  const year = params.get('year');

  // Only act on YMM-generated Porsche searches
  if (!make || make.toLowerCase() !== 'porsche' || !year) return;

  // YMM year values look like:
  // 2015-2026 (95B)
  // 2020-2026 (992)
  // 2012-2019 (991)
  // 2012-2025 (981/718)
  // 2005-2012 (997)
  // 2005-2012 (987)
  const generationMatch = year.match(/\(([^)]+)\)/);

  if (!generationMatch) return;

  const generation = generationMatch[1].trim().toLowerCase();

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  const normalizedGeneration = normalize(generation);

  function getProducts() {
    return window.ShopifyAnalytics?.meta?.products || [];
  }

  function fixYmmCards() {
    const products = getProducts();

    if (!products.length) return;

    document.querySelectorAll('product-card[handle]').forEach((card) => {
      const handle = card.getAttribute('handle');

      if (!handle) return;

      const product = products.find((p) => {
        return p.handle === handle;
      });

      if (!product || !Array.isArray(product.variants)) return;

      const variant = product.variants.find((v) => {
        const title = normalize(
          v.public_title ||
          v.publicTitle ||
          v.title ||
          v.name
        );

        return title.includes(normalizedGeneration);
      });

      if (!variant || !variant.id) return;

      const variantId = String(variant.id);

      /*
       * Fix every product-page link inside this card.
       * Preserves Prestige's _pos, _sid and _ss parameters.
       */
      card.querySelectorAll('a[href]').forEach((link) => {
        try {
          const url = new URL(link.href, window.location.origin);

          if (url.pathname === `/products/${handle}`) {
            url.searchParams.set('variant', variantId);

            link.href =
              url.pathname +
              url.search +
              url.hash;
          }
        } catch (e) {
          // Ignore malformed/non-product URLs
        }
      });

      /*
       * Fix Prestige Quick Buy.
       */
      const quickBuy = card.querySelector('quick-buy-modal');

      if (quickBuy) {
        quickBuy.setAttribute(
          'handle',
          `${handle}?variant=${variantId}`
        );
      }
    });
  }

  // Run once immediately
  fixYmmCards();

  // Run again once the page has fully initialized
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixYmmCards);
  }

  window.addEventListener('load', fixYmmCards);

  // Covers Shopify dynamically re-rendering search results
  document.addEventListener('shopify:section:load', fixYmmCards);
})();

/* ============================================================
   RennMount Require Series Selection
   ------------------------------------------------------------
   Applies to:
   - /products/wireless-charging-mount
   - /products/magnetic-mount

   Direct visit without ?variant=:
   1. Clears Prestige's automatic first-variant selection
   2. Removes Prestige's automatically appended ?variant=
   3. Disables Add to Cart
   4. Changes button text to "SELECT SERIES ABOVE"

   After customer selects a Series:
   1. Prestige handles the variant normally
   2. Add to Cart is enabled
   3. Button text returns to its original text

   Direct URLs that already contain ?variant= are left untouched.
   ============================================================ */

(function () {
  const REQUIRE_SELECTION_PRODUCTS = [
    '/products/wireless-charging-mount',
    '/products/magnetic-mount'
  ];

  // Only run on the two mount product pages.
  if (!REQUIRE_SELECTION_PRODUCTS.includes(window.location.pathname)) return;

  /*
   * Determine the URL that originally loaded the document.
   *
   * Prestige may automatically append ?variant= to window.location
   * before this custom script runs. The browser navigation entry
   * preserves the URL that actually initiated the page load.
   */
  const navigationEntry = performance.getEntriesByType('navigation')[0];

  const originalUrl = new URL(
    navigationEntry ? navigationEntry.name : window.location.href
  );

  const enteredWithVariant = originalUrl.searchParams.has('variant');

  /*
   * If the customer intentionally arrived through a variant-specific
   * URL (including YMM links), leave Prestige completely alone.
   */
  if (enteredWithVariant) return;

  let customerHasSelected = false;

  /*
   * Get only the Series radios.
   * Series is option position 1 on these products.
   */
  function getSeriesRadios() {
    return document.querySelectorAll(
      'variant-picker input[type="radio"][data-option-position="1"]'
    );
  }

  /*
   * Get the normal Add to Cart button(s).
   */
  function getAddToCartButtons() {
    return document.querySelectorAll(
      'product-form buy-buttons button[type="submit"]'
    );
  }

  /*
   * Prestige may wrap the visible button text in its own element.
   * If it does, use that element. Otherwise use the button itself.
   */
  function getButtonTextElement(button) {
    return button.querySelector('.button__text') || button;
  }

  /*
   * Change ATC to SELECT SERIES ABOVE while preserving Prestige's
   * original button text so it can be restored later.
   */
  function setSelectSeriesText() {
    getAddToCartButtons().forEach((button) => {
      const textElement = getButtonTextElement(button);

      if (!button.dataset.rennmountOriginalText) {
        button.dataset.rennmountOriginalText =
          textElement.textContent.trim();
      }

      textElement.textContent = 'SELECT SERIES ABOVE';
    });
  }

  /*
   * Restore Prestige's original Add to Cart wording.
   */
  function restoreAddToCartText() {
    getAddToCartButtons().forEach((button) => {
      const textElement = getButtonTextElement(button);

      if (button.dataset.rennmountOriginalText) {
        textElement.textContent =
          button.dataset.rennmountOriginalText;
      }
    });
  }

  /*
   * Initial state:
   *
   * - No Series selected
   * - ATC disabled
   * - ATC reads SELECT SERIES ABOVE
   * - Remove Prestige's automatically appended variant ID
   */
  function forceUnselectedState() {
    if (customerHasSelected) return;

    getSeriesRadios().forEach((radio) => {
      radio.checked = false;
    });

    getAddToCartButtons().forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.style.opacity = '0.75';
    });

    setSelectSeriesText();

    /*
     * Prestige automatically adds the first variant to the URL.
     * Remove only the variant parameter while preserving any other
     * query parameters, tracking parameters and hash.
     */
    const url = new URL(window.location.href);

    url.searchParams.delete('variant');

    window.history.replaceState(
      {},
      '',
      url.pathname + url.search + url.hash
    );
  }

  /*
   * Customer has made an explicit Series selection.
   */
  function unlockAddToCart() {
    customerHasSelected = true;

    getAddToCartButtons().forEach((button) => {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
       button.style.opacity = '';
    });

    restoreAddToCartText();
  }

  /*
   * Initialize after the product form exists.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      forceUnselectedState
    );
  } else {
    forceUnselectedState();
  }

  /*
   * Prestige performs some initialization after DOM ready.
   * Reassert our desired initial state after those operations.
   */
  window.addEventListener('load', forceUnselectedState);

  setTimeout(forceUnselectedState, 0);
  setTimeout(forceUnselectedState, 100);
  setTimeout(forceUnselectedState, 500);

  /*
   * Detect the customer's actual Series selection.
   *
   * Capture phase allows us to see the selection immediately while
   * still allowing Prestige to process the variant normally.
   */
  document.addEventListener(
    'change',
    function (event) {
      const radio = event.target.closest(
        'variant-picker input[type="radio"][data-option-position="1"]'
      );

      if (!radio) return;

      unlockAddToCart();
    },
    true
  );
})();